module.exports = __webpack_public_path__ + "img/1.268fafb1.png";